'use client';

import { Loader2 } from 'lucide-react';

import { useVideoRecording } from '../video-recording-provider';
import { VideoContainer, VideoElement } from './shared';

export function UploadingView() {
	const { videoRef, videoState, uploadState, uiState } = useVideoRecording();

	return (
		<VideoContainer
			badge={
				<span className="flex items-center gap-1 rounded-full bg-blue-100 px-2 py-1 text-xs font-semibold text-blue-700">
					<Loader2 className="h-4 w-4 animate-spin text-blue-500" /> Saving...{' '}
					{uploadState.progress > 0 && `${Math.round(uploadState.progress)}%`}
				</span>
			}
		>
			<VideoElement
				ref={videoRef}
				src={videoState.savedVideoUrl || videoState.recordedVideoUrl}
				muted={false}
				isPortrait={uiState.isPortrait}
			/>
		</VideoContainer>
	);
}
